// extracted by mini-css-extract-plugin
export default {"asideMenu":"AsideMenu_asideMenu__c9Hm0","hide":"AsideMenu_hide__6MYmQ"};